export const dev = {
    awsConfig: {
        "aws_project_region": "ap-southeast-2",
        "aws_cognito_region": "ap-southeast-2",
        "aws_user_pools_id": "ap-southeast-2_TgQHONcxR",
        "aws_user_pools_web_client_id": "3ukp55k3o0k45lgqgvvc4pssmm",
    },
    halterConfig: {
        "halter_api_url": "https://api.dev.halter.io",
    },
};
export const staging = {
    awsConfig: {
        "aws_project_region": "ap-southeast-2",
        "aws_cognito_region": "ap-southeast-2",
        "aws_user_pools_id": "ap-southeast-2_QEQyfsj09",
        "aws_user_pools_web_client_id": "114sct195gtg3mirrsspv5rpfq",
    },
    halterConfig: {
        "halter_api_url": "https://api.staging.halter.io",
    },
};
export const prod = {
    awsConfig: {
        "aws_project_region": "ap-southeast-2",
        "aws_cognito_region": "ap-southeast-2",
        "aws_user_pools_id": "ap-southeast-2_sMhqq7MQr",
        "aws_user_pools_web_client_id": "5mk4pofas2qbqn8kep9houso2h",
    },
    halterConfig: {
        "halter_api_url": "https://api.prod.halter.io",
    },
};
export const environment = 'prod';
